
import React, { useEffect, useState, useContext, useMemo } from 'react';
import JobCard from '../components/JobCard';
import { createAxiosInstance } from "../api/axios";
import { ErrorContext } from "../context/ErrorContext";
import { AuthContext } from "../context/AuthContext";
import { Box, Typography, Container, Paper, Grid, CircularProgress } from '@mui/material';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

const ApplicationSelfList = () => {
  const [applications, setApplications] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const { setError } = useContext(ErrorContext);
  const { user } = useContext(AuthContext);

  const authAxios = useMemo(() => {
      return createAxiosInstance(null);
  }, []);

    const fetchJobs = async () => {
    try {
      setIsLoading(true)
      const response = await authAxios.get('/application/', { params: { limit: 100 } })
      setApplications(response.data.results)
    } catch (error) {
      setError("Failed to fetch applications")
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchJobs();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!user) return <></>

  return (
    <Box sx={{ 
      minHeight: '100vh', 
      background: 'linear-gradient(135deg, #60a5fa 0%, #fb923c 100%)',
      py: 4,
      px: 2
    }}>
      <Container maxWidth="xl">
        <Paper sx={{ 
          background: 'rgba(255, 255, 255, 0.95)',
          borderRadius: 3,
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          backdropFilter: 'blur(10px)',
          p: 4,
          mb: 4
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, pb: 3, borderBottom: '2px solid #f0f0f0' }}>
            <AssignmentTurnedInIcon sx={{ fontSize: 32, color: 'primary.main', mr: 2 }} />
            <Typography variant="h4" fontWeight={700} sx={{ color: 'primary.main' }}>
              My Applications
            </Typography>
            {/* {user.is_recruiter && (
              <Button
                variant="contained"
                color="primary"
                size="large"
                startIcon={<AddIcon />}
                onClick={() => window.location.href = '/manual-application-add/'}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  px: 3,
                  py: 1.5,
                  borderRadius: 2,
                  boxShadow: '0 4px 12px rgba(25, 118, 210, 0.3)',
                  ml: 'auto',
                  '&:hover': {
                    boxShadow: '0 6px 16px rgba(25, 118, 210, 0.4)',
                  }
                }}
              >
                Add Manually
              </Button>
            )} */}
          </Box>
          <Box sx={{ mt: 3 }}>
            {isLoading ? (
              <Box sx={{ 
                textAlign: 'center', 
                py: 8,
                background: 'linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%)',
                borderRadius: 2,
                border: '1px solid #e3f2fd'
              }}>
                <CircularProgress size={48} sx={{ color: 'primary.main', mb: 2 }} />
                <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
                  Loading Your Applications
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                  Please wait while we fetch your applications...
                </Typography>
              </Box>
            ) : applications.length === 0 ? (
              <Box sx={{ 
                textAlign: 'center', 
                py: 8,
                background: 'linear-gradient(135deg, #f8f9ff 0%, #e8f2ff 100%)',
                borderRadius: 2,
                border: '1px solid #e3f2fd'
              }}>
                <AssignmentTurnedInIcon sx={{ fontSize: 64, color: 'primary.main', mb: 2, opacity: 0.6 }} />
                <Typography variant="h6" sx={{ color: 'text.secondary', mb: 1 }}>
                  No Applications Found
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
                  You haven't applied to any jobs yet.
                </Typography>
              </Box>
            ) : (
              <Grid container spacing={3} justifyContent="flex-start">
                {applications.map((application, idx) => {
                  // Reconstruct job object from flat response
                  const job = {
                    uuid: application.job_uuid,
                    title: application.job_title,
                    location: application.job_location,
                    salary: application.salary,
                    // Add other fields that JobCard might need
                  };
                  return (
                    <Grid item key={idx} xs={12} sm={6} md={4} lg={3}>
                      <JobCard job={job} status={application.status} />
                    </Grid>
                  );
                })}
              </Grid>
            )}
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default ApplicationSelfList;
